<template>
    <div class="container">
        <div class="common-header-wrap">
            <!-- <mt-header :title="$t('Promotion member')" class="common-header"> -->
            <mt-header :title="$t('Invite friends')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="text">
            <p>Invite your friends</p>
            <p>and enjoy the gifts</p>
        </div>

        <div class="box">
            <div class="t">{{ $t('Invitation code') }}</div>
            <div class="code">{{ code }}</div>
            <div class="dcpoy" @click="copySuccess(code)">{{ $t('Copy') }}</div>
            <div class="url">{{ inviter_url }}</div>
            <div class="xcpoy" @click="copySuccess(inviter_url)">{{ $t('Copy') }}</div>
        </div>
    </div>
</template>

<script>
import { getInviterPoster } from '../../../api/memberInviter'
import { Toast } from 'mint-ui'
export default {
    components: {
    },
    computed: {
    },
    data() {
        return {
            inviter_url: '',
            code: '',
        }
    },
    created() {

        getInviterPoster().then(res => {

            this.inviter_url = res.result.inviter_url
            this.code = this.inviter_url.match(/inviter_id=([^&]+)/)[1]

        }).catch(function (error) {
            Toast(error.message)
        })
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    beforeDestroy() {
    },
    methods: {
        copySuccess(sn) {
            this.$copyText(sn).then(
                (e) => {
                    Toast(this.$t('succ'))
                    // console.log(e);
                }, (e) => {
                    Toast(this.$t('err'))
                    // console.log(e);
                }
            );
        },
    }
}
</script>
<style scoped lang="scss">
.container {
    background-image: url('../../../assets/image/home/ifbgi.png');
    background-size: cover;
    background-repeat: no-repeat;
    
    background-color: #fff;
    overflow: hidden;
    /* 禁止滚动 */
    height: 100%;
    /* 保证高度撑满父容器 */

    .common-header {
        background: transparent;
        box-shadow: none;
    }

    .text {
        margin: 4rem auto;
        font-weight: 600;
        font-size: 1.8rem;
        color: #F91926;
        text-align: center;
    }

    .box {
        margin: 8rem auto 0;
        width: 16.6rem;
        height: 17.1rem;
        padding: 1px;
        background-image: url('../../../assets/image/home/ifb.png');
        background-size: cover;
        background-repeat: no-repeat;

        .t {
            font-size: .7rem;
            color: #FFFFFF;
            width: 7rem;
            height: 1.6rem;
            text-align: center;
            line-height: 1.6rem;
            margin: 1rem auto 0;
            background-image: url('../../../assets/image/home/ifbt.png');
            background-size: cover;
            background-repeat: no-repeat;
        }

        .code {
            margin: 2rem auto 0;
            font-weight: 600;
            font-size: 1.8rem;
            color: #F91926;
            text-align: center;
        }

        .dcpoy {
            margin: .6rem auto 0;
            font-size: .6rem;
            color: #F91926;
            width: 4rem;
            height: 2rem;
            text-align: center;
            line-height: 2rem;
            background: #FFF6EE;
            border-radius: 10px 10px 10px 10px;
            border: 1px solid #E7010C;
        }

        .url {
            width: 11rem;
            margin: 2rem auto 0;
            font-size: .6rem;
            color: #F91926;
            word-break: break-all;
        }

        .xcpoy {
            margin: .5rem auto 0;
            font-size: .5rem;
            color: #F91926;
            width: 2.5rem;
            height: 1.5rem;
            text-align: center;
            line-height: 1.5rem;
            background: #FFF6EE;
            border-radius: 10px 10px 10px 10px;
            border: 1px solid #E7010C;
        }

    }
}
</style>
